import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'

export const DATA_FEEDS_S3_RADIO_MAPPING = [
  { key: 'yes', label: 'Yes', type: RadioButtonType.STANDARD },
  { key: 'no', label: 'No', type: RadioButtonType.STANDARD },
]

export const STACK_DEPLOYMENT_RADIO_MAPPING: RadioButtonGroupMapping[] = [
  {
    key: 'cloudformation',
    label: 'Cloudformation Stack',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'terraform',
    label: 'Terraform Stack',
    type: RadioButtonType.STANDARD,
  },
]

export const LOCKED_CHOICE_TOOLTIP =
  'This option is disabled because it was not selected during onboarding.'

export const TERRAFORM_DISABLE_YES_TOOLTIP =
  'This option is not available for Terraform Stack. Please contact the Customer Support team for onboarding assistance.'

export const CLOUDFORMATION_STACK_DESCRIPTION =
  'In this section, connect your cloud environment to create and manage listings via Labra and set up Data Feeds to track invoices and disbursements. Click ‘Launch CloudFormation Stack’ to complete the setup and create the required resources.\n' +
  'Note: Ensure the stack name uses only lowercase letters and hyphens (-), with no spaces.'

export const TERRAFORM_STACK_DESCRIPTION =
  'In this section, connect your cloud environment to create and manage listings via Labra and set up Data Feeds to track invoices and disbursements.\n' +
  'To complete the setup using Terraform, download template, provide the required AWS resources using your Terraform configuration. Once the setup is complete, retrieve the output values and paste them into the respective fields below.\n' +
  'Note: Ensure Terraform CLI is installed and AWS credentials are configured before running your setup.\n'
